

import React, { useRef } from 'react';
import { List, ListItem, Typography } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { EmptyListResultTable } from '../EmptyResult/EmptyListResult';
import { SentinelInfiniteScroll } from 'modules/app/reactComponents/shared/components/SentinelInfiniteScroll';


export type ListModalProps = {
    items: ModalItem[],
    searchText: string,
    onSelect: (id: string) => void
    OnRowsScrollEnd?: () => void
    hasMoreValue?: boolean
}
export type ModalItem = { id: string, title: string, subTitle?: string }

export const ListSelectModal = (props: ListModalProps) => {
    const { t } = useTranslation(['common'])

    const containerListRef = useRef()

    return (
        <>
            {
                props.items.length == 0 &&
                <EmptyListResultTable
                    text={t('idhaModal.variantMessage.empty')}
                />
            }
            <List component="ul" ref={containerListRef.current}>
                {
                    props.items
                        .map((item, idx) => (
                            <ListItem
                                key={idx}
                                divider
                                alignItems={"center"}
                                button
                                onClick={() => props.onSelect(item.id)}
                            >
                                <div >
                                    <div >
                                        <Typography
                                            style={{ color: 'rgba(0, 0, 0, 0.80)' }}
                                            variant="body1"
                                        >
                                            {item?.title}
                                        </Typography>
                                        <Typography color="textSecondary" variant="body2">
                                            {item?.subTitle}
                                        </Typography>
                                    </div>
                                </div>
                            </ListItem>
                        ))
                }
                {
                    props.OnRowsScrollEnd && !props.searchText &&
                    <SentinelInfiniteScroll
                        fetchMore={props.OnRowsScrollEnd}
                        ref={containerListRef.current}
                        hasMoreValue={props.hasMoreValue}
                    />
                }

            </List>

        </>

    )

};



